/* eslint-disable import/no-cycle */
import {
  arrayOf,
  customType,
  extend,
  fragment,
  params,
  shape,
  string,
  number,
  bool
} from '@thd-nucleus/data-sources';

const plccPromotionDataModel = shape({
  id: string(),
  offer: string(),
  deferredDisclosure: string(),
});

const dateRange = shape({
  id: string(),
  startDate: string(),
  endDate: string()
});

const plccDrawerModel = shape({
  id: string(),
  title: string(),
  componentName: string(),
  newAccountOfferDisclosure: string(),
  paymentEstimatorTila: string(),
  standardTila: string(),
  everydayPromotion: plccPromotionDataModel,
  appliancePromotion: plccPromotionDataModel,
  tieredPromotion: plccPromotionDataModel,
  twelveMonthPromotion: plccPromotionDataModel,
  tieredAppliancePromotion: plccPromotionDataModel,
  __typename: string()
});

const plccPromoInfoModel = shape({
  componentName: string(),
  id: string(),
  everydayDfp: string(),
  applianceDfp: string(),
  tieredDfp: string(),
  twelveMonthsSpecialDfp: string(),
  tieredApplianceDfp: string(),
  crcDfp: string(),
  appliancePromoDates: arrayOf(dateRange),
  tieredPromoDates: arrayOf(dateRange),
  twelveMonthSpecialPromoDates: arrayOf(dateRange),
  tieredApplianceDates: arrayOf(dateRange),
  publishDate: string(),
});

const plccOfferDataModel = shape({
  id: string(),
  componentName: string(),
  name: string(),
  copyExtraSmall: string(),
  copySmall: string(),
  copyRegular: string(),
});

const plccInlineComponent = fragment().shape({
  componentName: string(),
  id: string(),
  plccOffer: plccOfferDataModel,
  campaignCode: string(),
  offerCopySize: string(),
  cardImage: shape({
    id: string(),
    damContentSelector: shape({
      assetData: arrayOf(
        shape({
          selectedImageDimensions: string(),
          selectedImageUrl: string()
        })
      )
    }),
  }),
  backgroundImage: shape({
    id: string(),
    damContentSelector: shape({
      assetData: arrayOf(
        shape({
          selectedImageDimensions: string(),
          selectedImageUrl: string()
        })
      )
    }),
  }),
  ctaCopy: string(),
  plccDrawerContent: plccDrawerModel,
  plccPromoInfo: plccPromoInfoModel,
  hideCta: bool()
});

export const PlccHDHomeDataModel = extend({
  component: params({
    id: string().isRequired(),
    componentClass: customType('ComponentClass').enum(['PlccInlineComponent']).isRequired(),
  }).shape({
    PlccInlineComponent: plccInlineComponent
  }),
});
